// 底层组件库
import barOption from "./components/bar";
import datetimeOption from "./components/datetime";
import flopOption from "./components/flop";
import funnelOption from "./components/funnel";
import gaugeOption from "./components/gauge";
import iframeOption from "./components/iframe";
import imgOption from "./components/img";
import imgborderOption from "./components/imgborder";
import lineOption from "./components/line";
import mapOption from "./components/map";
import pictorialbarOption from "./components/pictorialbar";
import pieOption from "./components/pie";
import progressOption from "./components/progress";
import radarOption from "./components/radar";
import scatterOption from "./components/scatter";
import swiperOption from "./components/swiper";
import tableOption from "./components/table";
import tabsOption from "./components/tabs";
import textOption from "./components/text";
import videoOption from "./components/video";
import clapperOption from "./components/clapper";
import commonOption from "./components/common";
import wordcloudOption from "./components/wordcloud";
import datavOption from "./components/datav";
import timeOption from "./components/time"; //通用配置

import mainOption from "./components/main"; //自定义组件库

import testOption from '@/views/visual/dataScreen/components/test/option';
import imgTabsOption from '@/views/visual/dataScreen/components/imgTabs/option';
import imgListOption from '@/views/visual/dataScreen/components/imgList/option';
export default {
  components: {
    commonOption: commonOption,
    mainOption: mainOption,
    barOption: barOption,
    datetimeOption: datetimeOption,
    flopOption: flopOption,
    funnelOption: funnelOption,
    gaugeOption: gaugeOption,
    iframeOption: iframeOption,
    imgOption: imgOption,
    imgborderOption: imgborderOption,
    lineOption: lineOption,
    mapOption: mapOption,
    pictorialbarOption: pictorialbarOption,
    pieOption: pieOption,
    progressOption: progressOption,
    radarOption: radarOption,
    scatterOption: scatterOption,
    swiperOption: swiperOption,
    tableOption: tableOption,
    tabsOption: tabsOption,
    textOption: textOption,
    videoOption: videoOption,
    clapperOption: clapperOption,
    wordcloudOption: wordcloudOption,
    datavOption: datavOption,
    timeOption: timeOption,
    testOption: testOption,
    imgTabsOption: imgTabsOption,
    imgListOption: imgListOption
  }
};